import { createSlice } from 'redux-starter-kit'
import { STATUS } from './constants'

const reduxNamespaceKey = 'aiTestDetails'

const initialState = {
  status: STATUS.INIT,
}

const slice = createSlice({
  slice: reduxNamespaceKey,
  initialState: { ...initialState },
  reducers: {
    getAiGeneratedTestItems: (state) => {
      state.status = STATUS.INPROGRESS
    },
    regenerateAiTestItems: (state) => {
      state.status = STATUS.INPROGRESS
    },
    updateAITestItem: () => {},
    setStatus: (state, { payload }) => {
      state.status = payload
    },
    resetTestDetails: (state) => {
      state.status = STATUS.INIT
    },
  },
})

const {
  getAiGeneratedTestItems,
  setStatus,
  resetTestDetails,
  regenerateAiTestItems,
  updateAITestItem,
} = slice.actions

export const actions = {
  getAiGeneratedTestItems,
  setStatus,
  resetTestDetails,
  regenerateAiTestItems,
  updateAITestItem,
}

export const { reducer } = slice

export { reduxNamespaceKey }
